//Size Dropdown
let atcBtn = document.querySelector('.atc-btn');

//Size Buttons
let sizeBtns = document.querySelectorAll('#size-buttons a');
if(sizeBtns){
  sizeBtns.forEach(function(item,i){
    item.addEventListener("click", function (event) {
      event.preventDefault();
      atcBtn.dataset.cartAdd = item.dataset.value;
      removeOthers(i);
      item.classList.add('selected');
      atcBtn.innerText = "Add To Bag";
      atcBtn.removeAttribute("disabled");
      atcBtn.classList.remove("disabled");
    });
  });

  let removeOthers = function(i){
    sizeBtns.forEach(function(jtem, j){
      if(i != j){
        jtem.classList.remove('selected');
      }
    });
  }
}

//Image Zoom
let gallery = document.querySelector('.product-pg');
let galleryLinks = gallery.querySelectorAll('.gallery a');

galleryLinks.forEach(function(item, i){
  item.addEventListener('click', function(event){
    event.preventDefault();
    gallery.classList.toggle('zoom');
    item.scrollIntoView();
    //let image = item.querySelector("img").src;
  });
});

//Swiper
let swiper = new Swiper(".mobile-gallery", {
  loop: true,
  pagination: {
    el: ".swiper-pagination",
  },
});